module.exports = __webpack_public_path__ + "img/data_icon_219962.55c7a566.png";